var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq43(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19844,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4348,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.0222,
    y1: 12.1824,
    x2: 50.2586,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.34841,
    y1: 49.8543,
    x2: 12.5847,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.7844,
    y1: 38.6199,
    x2: 50.0207,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.11057,
    y1: 0.944118,
    x2: 12.3469,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.476 27.62V26.878L23.572 20.018H24.734V26.766H26.232V27.62H24.734V30H23.768V27.62H18.476ZM23.81 21.096L19.61 26.766H23.81V21.096ZM27.4539 22.524C27.5193 21.6747 27.8459 21.0073 28.4339 20.522C29.0313 20.0273 29.8013 19.78 30.7439 19.78C31.3693 19.78 31.9059 19.892 32.3539 20.116C32.8019 20.34 33.1379 20.648 33.3619 21.04C33.5953 21.4227 33.7119 21.8567 33.7119 22.342C33.7119 22.93 33.5393 23.4387 33.1939 23.868C32.8486 24.2973 32.3586 24.5633 31.7239 24.666V24.736C32.3866 24.8667 32.9139 25.156 33.3059 25.604C33.6979 26.0427 33.8939 26.6213 33.8939 27.34C33.8939 28.1427 33.6233 28.8007 33.0819 29.314C32.5499 29.818 31.7753 30.07 30.7579 30.07C29.7873 30.07 28.9893 29.818 28.3639 29.314C27.7386 28.8007 27.3793 28.0773 27.2859 27.144H28.2379C28.3219 27.7693 28.5833 28.278 29.0219 28.67C29.4606 29.0527 30.0393 29.244 30.7579 29.244C31.4673 29.244 32.0086 29.0573 32.3819 28.684C32.7646 28.3107 32.9559 27.8347 32.9559 27.256C32.9559 25.8373 31.9339 25.128 29.8899 25.128H29.5819V24.302H29.9039C31.8079 24.302 32.7599 23.6813 32.7599 22.44C32.7599 21.8987 32.5826 21.4647 32.2279 21.138C31.8733 20.802 31.3693 20.634 30.7159 20.634C30.0813 20.634 29.5539 20.802 29.1339 21.138C28.7233 21.4647 28.4806 21.9267 28.4059 22.524H27.4539Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq43);
export default __webpack_public_path__ + "static/media/fq43.b9fbe9cf337fd2a1b97ead1dea961768.svg";
export { ForwardRef as ReactComponent };